module.exports = __webpack_public_path__ + "img/bootstrap-color.f3b984d6.svg";